module.exports = __webpack_public_path__ + "img/MDI-lightbulb-outline.3d23d16c.svg";